import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useMutation } from '@tanstack/react-query'
import { UpdateHighlightInput } from '../../../../domain/dtos/member-area/settings/update-highlight-input'
import { UpdateHighlight } from '../../../../usecases/member-area/settings/update-highlight'

export const useUpdateHighlight = () => {
  const container = useContainer()

  const { isSuccess, isError, error, isLoading, data, mutateAsync } = useMutation(
    [],
    (values: UpdateHighlightInput) => {
      return new UpdateHighlight(container.get(HttpClient)).execute(values)
    },
  )

  return {
    isSuccess,
    isError,
    error,
    isLoading,
    data,
    mutateAsync,
  }
}
